import React, { useState } from 'react';
import group from "../assets/images/Rectangle 18156.png";
import { HiOutlineDotsHorizontal } from "react-icons/hi";
import user from "../assets/images/user.png";
import checkbox from "../assets/icons/RadioCheckedBoxIcon.svg";
import nCheck from "../assets/icons/RadioNonCheckedIcon.svg";
import { useRedirect } from '../hooks/useRedirect';
import pathnames from '../routes/index.route';
import { TranslateIcon, VideoIcon } from '../assets/icons/Icons';

interface GroupFileCardProps {
  width?: string;
  className?: string;
  check?: boolean;
}

const GroupFileCard: React.FC<GroupFileCardProps> = ({ width, className, check = false }) => {
  const [selected, setSelected] = useState<boolean>(false);
  const redirect = useRedirect();
  return (
    <div className={`${width ? `w-[${width}]` : "w-[379px]"} h-[110px] rounded-xl bg-white flex items-center gap-2 ${className}`}>
      <img onClick={() => redirect(pathnames.content + pathnames.specificFileGroup)} src={group} className="w-[93px] h-[102px] cursor-pointer m-1 inline-block" alt="group" />
      <div className="w-full py-3 pr-3">
        <div className="flex justify-between">
          <p onClick={() => redirect(pathnames.content + pathnames.specificFileGroup)} className="text-[#0F0C18] cursor-pointer text-base font-medium tracking-tight">Game video</p>
          {
            !check ?
              <HiOutlineDotsHorizontal className="w-5 h-5 text-[#0F0C18] cursor-pointer" />
              :
              selected ? <img onClick={() => setSelected(false)} src={checkbox} className="cursor-pointer" alt="check" /> :
                <img onClick={() => setSelected(true)} src={nCheck} className="cursor-pointer" alt="check" />
          }
        </div>
        <div className="flex items-center gap-[6px] mt-[6px]">
          <img src={user} className="w-4 h-4 rounded-full" alt="user" />
          <p className="text-[#0F0C18] text-xs font-medium tracking-tight">Andrew Wack</p>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-[7px] mt-[6px]">
            <VideoIcon width={16} height={16} stroke="#0F0C18" />
            <div className="text-[#9392A2] text-xs font-medium tracking-tight">Video content</div>
          </div>
          <p className="text-[#0F0C18] text-xs font-medium tracking-tight">15</p>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-[7px] mt-[6px]">
            <TranslateIcon />
            <div className="text-[#9392A2] text-xs font-medium tracking-tight">Languages</div>
          </div>
          <p className="text-[#0F0C18] text-xs font-medium tracking-tight">13</p>
        </div>
      </div>
    </div>
  );
};

export default GroupFileCard;